export default __webpack_public_path__ + "static/media/up.20170695.svg";